import { ConversationCheckoutOrderSummary } from '../../../../components/ConversationOrderSummary'
import { useCartContext } from '../../../../providers/CartProvider'
import { toOrderSummaryDeliveryGroups } from '../../../../utils/toOrderSummaryDeliveryGroups'
import { type ConversationCheckoutComponent } from '../../../../value-objects/ConversationTurnItem'

export interface IConversationCheckoutProps {
  checkout: ConversationCheckoutComponent
  onSendMessage: (message: string) => void
}

export const ConversationCheckout = ({
  checkout,
  onSendMessage,
}: IConversationCheckoutProps) => {
  const { decorate, isContinuing, continueToOrderRequest } = useCartContext()

  const { items, total, currency, disabled } = decorate(checkout)
  const continueMessage = checkout.continueAction?.message
  const handleContinue = continueMessage
    ? () => onSendMessage(continueMessage)
    : continueToOrderRequest

  return (
    <ConversationCheckoutOrderSummary
      groups={toOrderSummaryDeliveryGroups(checkout.vendors, items)}
      total={total}
      currency={currency}
      charges={checkout.charges}
      disabled={disabled}
      totalLabel={checkout.totalLabel}
      continueAction={checkout.continueAction}
      disclaimer={checkout.disclaimer}
      isContinueLoading={isContinuing}
      onContinue={handleContinue}
      onSendMessage={onSendMessage}
    />
  )
}
